export enum DialogEventTabs {
  Details = 'details',
  History = 'history',
}
